<div class="row">
    <div class="col">
        <strong>{{lang}} - {{lang | translate}}</strong>
    </div>
</div>
<div>
    <button [ngClass]="[currentNewsletterState.wantsNewsletter ? 'btn-gray' : '']" class="button btn-poettinger"
        (click)="onSignup()" style="margin-right: 5px;min-width: max-content;">{{'signup' | translate}}</button>

    <button [ngClass]="[currentNewsletterState.wantsNewsletter ? '' : ' btn-gray']" class="button btn-poettinger"
        (click)="onSignout()" style="min-width: max-content;">{{'signout' | translate}}</button>
</div>
<div class="row">
    @if (currentNewsletterState.wantsNewsletter) {
    <div class="col">
        <p>{{'abosince' | translate}}: {{currentNewsletterState.dateOfChange | date:'dd.MM.yyyy'}}</p>
    </div>
    }
</div>